export const filterStatus = {
  START: 'inicio',
  END: 'fim',
  DOCUMENT: 'documentos',
  FLOW: 'fluxoIds',
  PROTOCOL: 'protocolos',
  STATUS: 'listaStatus',
};
